/**
 * TanStack Query hooks for `duplicate-conversion-prevention`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	duplicateConversionPreventionQueryKeys,
	type CreateDuplicateConversionPreventionBody,
	type ListDuplicateConversionPreventionResponse,
	type DuplicateConversionPreventionRow,
} from "./api";

export function useDuplicateConversionPreventionList(): UseQueryResult<ListDuplicateConversionPreventionResponse, Error> {
	return useQuery({
		queryKey: duplicateConversionPreventionQueryKeys.list(),
		queryFn: list,
	});
}

export function useDuplicateConversionPreventionCreate(): UseMutationResult<DuplicateConversionPreventionRow, Error, CreateDuplicateConversionPreventionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: duplicateConversionPreventionQueryKeys.all });
		},
	});
}

export function useDuplicateConversionPreventionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: duplicateConversionPreventionQueryKeys.all });
		},
	});
}
